

import angular from 'angular';

import * as LicenseAttachmentTypes from './LicenseAttachmentTypes.constant';
import * as LicenseIntegrationTypes from './LicenseIntegrationTypes.constant';
import * as LicenseRejectReasons from './LicenseRejectReasons.constant';
import * as LicenseTemplateUrls from './LicenseTemplateUrls.constant';
import * as LicenseTypes from './LicenseTypes.constant';
import * as LogLevels from './logLevels.constant';
import * as HPProjectAdvanceReasons from './hpProjectAdvanceReasons.constant';
import * as PipelineStages from './PipelineStages.constant';
import * as HPStateMachineConfig from './StateMachine.constant';
import * as ConditionTypes from './ConditionTypes.constant';
import * as AddProductsConfig from './AddProductsConfig.constant';
import * as NotificationTypes from './NotificationTypes.constant';
import * as NotificationPrioirty from './NotificationPriorityTypes.constant';
import * as NotificationUpdateableTypes from './NotificationUpdateableTypes.constant';
import * as TrainingTypes from './TrainingTypes.constant';
import * as ActionItemTypes from './ActionItemStatusTypes.constant';
import * as ActionItemCategoryTypes from './ActionItemCategoryTypes.constant';
import * as ActionItemUrls from './ActionItemUrls.constant';

export default angular.module('app.config.constants', [])
    .constant('LicenseAttachmentTypes', LicenseAttachmentTypes.default)
    .constant('LicenseIntegrationTypes', LicenseIntegrationTypes.default)
    .constant('LicenseRejectReasons', LicenseRejectReasons.default)
    .constant('LicenseTemplateUrls', LicenseTemplateUrls.default)
    .constant('LicenseTypes', LicenseTypes.default)
    .constant('HPLogging', LogLevels.default)
    .constant('HPProjectAdvance', HPProjectAdvanceReasons.default)
    .constant('HPPipelineStages', PipelineStages.default)
    .constant('HPStateMachineConfig', HPStateMachineConfig.default)
    .constant('HPConditionTypes', ConditionTypes.default)
    .constant('AddProductsConfig', AddProductsConfig.default)
    .constant('HPNotifications', NotificationTypes.default)
    .constant('HPNotificationPriority', NotificationPrioirty.default)
    .constant('HPUpdatableNotifications', NotificationUpdateableTypes.default)
    .constant('HPTrainingType', TrainingTypes.default)
    .constant('HPActionItemStatuses', ActionItemTypes.default)
    .constant('HPActionItemCategories', ActionItemCategoryTypes.default)
    .constant('HPActionItemUrls', ActionItemUrls.default)
    .name;



// WEBPACK FOOTER //
// ./src/app/config/constants/index.js